import React, { useContext } from 'react'
import { View } from 'react-native'
import ColoredText from '@webstollen/react-native/lib/components/CustomText/ColoredText'
import { useRouteMatch } from '@webstollen/react-native/lib/react-router'
import { SemVer } from 'semver'
import LoadingScreen from '@webstollen/react-native/lib/components/LoadingScreen'
import { isLoaded } from 'react-redux-firebase'
import { useTranslation } from 'react-i18next'
import useStyles from './styles'
import OrderV1 from './v1'
import { SessionContext } from '../../../../context/SessionContext'

const Order = () => {
  const styles = useStyles()

  const { t } = useTranslation()

  const match = useRouteMatch<{ shopId: string; orderId: string }>()

  const { shopId, orderId } = match.params

  const { shops } = useContext(SessionContext)
  const shop = shops && shops[shopId]

  if (!isLoaded(shop)) {
    return <LoadingScreen text={t('loading.shop')} />
  }

  const version = new SemVer(shop.platform.sdkVersion)

  switch (version.major) {
    case 1:
      return <OrderV1 shop={shop} orderId={orderId} />
    default:
      return (
        <View style={styles.wrapper}>
          <View style={styles.container}>
            <ColoredText>{JSON.stringify(shop, null, 2)}</ColoredText>
          </View>
        </View>
      )
  }
}

export default Order
